(ns shared.core.constants)

(def state-code->state
  {"AL" "Alabama"
   "AK" "Alaska"
   "AZ" "Arizona"
   "AR" "Arkansas"
   "CA" "California"
   "CO" "Colorado"
   "CT" "Connecticut"
   "DE" "Delaware"
   "DC" "District Of Columbia"
   "FL" "Florida"
   "GA" "Georgia"
   "HI" "Hawaii"
   "ID" "Idaho"
   "IL" "Illinois"
   "IN" "Indiana"
   "IA" "Iowa"
   "KS" "Kansas"
   "KY" "Kentucky"
   "LA" "Louisiana"
   "ME" "Maine"
   "MD" "Maryland"
   "MA" "Massachusetts"
   "MI" "Michigan"
   "MN" "Minnesota"
   "MS" "Mississippi"
   "MO" "Missouri"
   "MT" "Montana"
   "NE" "Nebraska"
   "NV" "Nevada"
   "NH" "New Hampshire"
   "NJ" "New Jersey"
   "NM" "New Mexico"
   "NY" "New York"
   "NC" "North Carolina"
   "ND" "North Dakota"
   "OH" "Ohio"
   "OK" "Oklahoma"
   "OR" "Oregon"
   "PA" "Pennsylvania"
   "RI" "Rhode Island"
   "SC" "South Carolina"
   "SD" "South Dakota"
   "TN" "Tennessee"
   "TX" "Texas"
   "UT" "Utah"
   "VT" "Vermont"
   "VA" "Virginia"
   "WA" "Washington"
   "WV" "West Virginia"
   "WI" "Wisconsin"
   "WY" "Wyoming"})

(def american-timezones
  ["America/Adak"
   "America/Anchorage"
   "America/Anguilla"
   "America/Antigua"
   "America/Araguaina"
   "America/Argentina/Buenos_Aires"
   "America/Argentina/Catamarca"
   "America/Argentina/ComodRivadavia"
   "America/Argentina/Cordoba"
   "America/Argentina/Jujuy"
   "America/Argentina/La_Rioja"
   "America/Argentina/Mendoza"
   "America/Argentina/Rio_Gallegos"
   "America/Argentina/Salta"
   "America/Argentina/San_Juan"
   "America/Argentina/San_Luis"
   "America/Argentina/Tucuman"
   "America/Argentina/Ushuaia"
   "America/Aruba"
   "America/Asuncion"
   "America/Atikokan"
   "America/Atka"
   "America/Bahia"
   "America/Barbados"
   "America/Belem"
   "America/Belize"
   "America/Blanc-Sablon"
   "America/Boa_Vista"
   "America/Bogota"
   "America/Boise"
   "America/Buenos_Aires"
   "America/Cambridge_Bay"
   "America/Campo_Grande"
   "America/Cancun"
   "America/Caracas"
   "America/Catamarca"
   "America/Cayenne"
   "America/Cayman"
   "America/Chicago"
   "America/Chihuahua"
   "America/Coral_Harbour"
   "America/Cordoba"
   "America/Costa_Rica"
   "America/Cuiaba"
   "America/Curacao"
   "America/Danmarkshavn"
   "America/Dawson"
   "America/Dawson_Creek"
   "America/Denver"
   "America/Detroit"
   "America/Dominica"
   "America/Edmonton"
   "America/Eirunepe"
   "America/El_Salvador"
   "America/Ensenada"
   "America/Fortaleza"
   "America/Fort_Wayne"
   "America/Glace_Bay"
   "America/Godthab"
   "America/Goose_Bay"
   "America/Grand_Turk"
   "America/Grenada"
   "America/Guadeloupe"
   "America/Guatemala"
   "America/Guayaquil"
   "America/Guyana"
   "America/Halifax"
   "America/Havana"
   "America/Hermosillo"
   "America/Indiana/Indianapolis"
   "America/Indiana/Knox"
   "America/Indiana/Marengo"
   "America/Indiana/Petersburg"
   "America/Indiana/Tell_City"
   "America/Indiana/Vevay"
   "America/Indiana/Vincennes"
   "America/Indiana/Winamac"
   "America/Indianapolis"
   "America/Inuvik"
   "America/Iqaluit"
   "America/Jamaica"
   "America/Jujuy"
   "America/Juneau"
   "America/Kentucky/Louisville"
   "America/Kentucky/Monticello"
   "America/Knox_IN"
   "America/La_Paz"
   "America/Lima"
   "America/Los_Angeles"
   "America/Louisville"
   "America/Maceio"
   "America/Managua"
   "America/Manaus"
   "America/Marigot"
   "America/Martinique"
   "America/Matamoros"
   "America/Mazatlan"
   "America/Mendoza"
   "America/Menominee"
   "America/Merida"
   "America/Mexico_City"
   "America/Miquelon"
   "America/Moncton"
   "America/Monterrey"
   "America/Montevideo"
   "America/Montreal"
   "America/Montserrat"
   "America/Nassau"
   "America/New_York"
   "America/Nipigon"
   "America/Nome"
   "America/Noronha"
   "America/North_Dakota/Center"
   "America/North_Dakota/New_Salem"
   "America/Ojinaga"
   "America/Panama"
   "America/Pangnirtung"
   "America/Paramaribo"
   "America/Phoenix"
   "America/Port-au-Prince"
   "America/Porto_Acre"
   "America/Port_of_Spain"
   "America/Porto_Velho"
   "America/Puerto_Rico"
   "America/Rainy_River"
   "America/Rankin_Inlet"
   "America/Recife"
   "America/Regina"
   "America/Resolute"
   "America/Rio_Branco"
   "America/Rosario"
   "America/Santa_Isabel"
   "America/Santarem"
   "America/Santiago"
   "America/Santo_Domingo"
   "America/Sao_Paulo"
   "America/Scoresbysund"
   "America/Shiprock"
   "America/St_Barthelemy"
   "America/St_Johns"
   "America/St_Kitts"
   "America/St_Lucia"
   "America/St_Thomas"
   "America/St_Vincent"
   "America/Swift_Current"
   "America/Tegucigalpa"
   "America/Thule"
   "America/Thunder_Bay"
   "America/Tijuana"
   "America/Toronto"
   "America/Tortola"
   "America/Vancouver"
   "America/Virgin"
   "America/Whitehorse"
   "America/Winnipeg"
   "America/Yakutat"
   "America/Yellowknife"
   "Pacific/Honolulu"])

(def hours-of-day ["12:00am" "1:00am" "2:00am" "3:00am" "4:00am" "5:00am" "6:00am" "7:00am" "8:00am" "9:00am" "10:00am"
                   "11:00am" "12:00pm" "1:00pm" "2:00pm" "3:00pm" "4:00pm" "5:00pm" "6:00pm" "7:00pm" "8:00pm" "9:00pm"
                   "10:00pm" "11:00pm"])
(def days-of-the-week ["Sunday" "Monday" "Tuesday" "Wednesday" "Thursday" "Friday" "Saturday"])
(def days-of-the-week-map (->> days-of-the-week
                               (map-indexed (fn [idx dow]
                                              [dow idx]))
                               (into {})))

(def car-makes
  ["Abarth"
   "Alfa Romeo"
   "Aston Martin"
   "Audi"
   "Bentley"
   "BMW"
   "Bugatti"
   "Cadillac"
   "Chevrolet"
   "Chrysler"
   "Citroën"
   "Dacia"
   "Daewoo"
   "Daihatsu"
   "Dodge"
   "Donkervoort"
   "DS"
   "Ferrari"
   "Fiat"
   "Fisker"
   "Ford"
   "Honda"
   "Hummer"
   "Hyundai"
   "Infiniti"
   "Iveco"
   "Jaguar"
   "Jeep"
   "Kia"
   "KTM"
   "Lada"
   "Lamborghini"
   "Lancia"
   "Land Rover"
   "Landwind"
   "Lexus"
   "Lotus"
   "Maserati"
   "Maybach"
   "Mazda"
   "McLaren"
   "Mercedes-Benz"
   "MG"
   "Mini"
   "Mitsubishi"
   "Morgan"
   "Nissan"
   "Opel"
   "Peugeot"
   "Porsche"
   "Renault"
   "Rolls-Royce"
   "Rover"
   "Saab"
   "Seat"
   "Skoda"
   "Smart"
   "SsangYong"
   "Subaru"
   "Suzuki"
   "Tesla"
   "Toyota"
   "Volkswagen"
   "Volvo"])
